import request from "../request"
// import qs from "qs";

/**
 * 连接websocket
 * @returns 
 */
 export function getFlightPathById(params) {
  return request.get({
    url: "route-information/list",
    params: params
  })
}
/**
 * 连接websocket
 * @returns 
 */
 export function connectWebsocket() {
  return request.get({
    url: "webSocket/list" //连接websocket
  })
}
/**
 * 获取可调配设备资源
 * @returns 
 */
 export function getEquipmentResource() {
  return request.get({
    url: "/facility/allList"
  })
}


/**
 * 获取地面资源
 * @returns 
 */
export function getGroundResource() {
  return request.get({
    url: "/ground_resource/allList"
  })
}


/**
 * 获取空域资源
 * @returns 
 */
export function getAirspaceResource() {
  return request.get({
    url: "/airspace/allList"
  })
}
/**
 * 获取飞行路线数据
 * @returns 
 */
export function getPlaneLineData(params) {
  return request.get({
    url: "/fly_plan/recentOne",
    params: params
  })
}

